<div class="wrap">
  <button *ngIf="!isLoadingZipAllOffers" matTooltip="Télécharger les images principales de chaque offre"
    (click)="downloadAllMainPicturesFromOffers()" appChangeColorTheme attribute="bgc" class="donwloadBtn">
    <fa-icon [icon]="getFaIcon('faDownload')"></fa-icon>
    Télécharger images
  </button>

  <mat-spinner class="spinnerZipAllOffers" *ngIf="isLoadingZipAllOffers" [diameter]="30" color="primary"></mat-spinner>

  <div class="table">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="offerKey">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="offerKey"> OfferKey
        </th>
        <td mat-cell *matCellDef="let element"> {{element.offerKey}}</td>
      </ng-container>

      <ng-container matColumnDef="offreNom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="offreNom" class="cell_text"> Nom de l'offre
        </th>
        <td mat-cell *matCellDef="let element" class="cell_text"> {{element.offerName}} </td>
      </ng-container>

      <ng-container matColumnDef="clubNom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="clubNom" class="cell_club"> Club </th>
        <td mat-cell *matCellDef="let element" class="cell_club"> {{element.clubCode}} </td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="price" class="cell_id"> Prix </th>
        <td mat-cell *matCellDef="let element" class="cell_id"> {{element.price}} </td>
      </ng-container>

      <ng-container matColumnDef="backoffice">
        <th mat-header-cell *matHeaderCellDef class="cell_backoffice"> BackOffice </th>
        <td mat-cell *matCellDef="let element" class="cell_backoffice">
          <fa-icon *ngIf="!element.isExternalOffer" [icon]="getFaIcon('faCheckCircle')" appChangeColorTheme
            attribute="color">
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="file">
        <th mat-header-cell *matHeaderCellDef class="cell_session">Fichiers</th>
        <td mat-cell *matCellDef="let element" class="cell_session">
          <fa-icon [icon]="getFaIcon('faFile')" [matTooltip]="getTooltip('goToFilesOffer')"
            (click)="goToFilesOffer(element)">
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="session">
        <th mat-header-cell *matHeaderCellDef class="cell_session">Sessions</th>
        <td mat-cell *matCellDef="let element" class="cell_session">
          <ng-container *ngIf="!element?.isExternalOffer && element.hasSession">
            <span *ngIf="element.sessions?.length " [matTooltip]="getTooltip('showSessionOffer')"
              (click)="$event.preventDefault(); addSession(element)" appChangeColorTheme attribute="color">
              {{ getLengthSession(element.sessions).length}} </span>
            <fa-icon *ngIf="!element.sessions?.length " [matTooltip]="getTooltip('addSessionOffer')"
              [icon]="getFaIcon('faPlus')" (click)="$event.preventDefault(); addSession(element)" appChangeColorTheme
              attribute="color"></fa-icon>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Aperçu </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faImage')" [matTooltip]="getTooltip('showPreview')"
            (click)="changePreview(element)" appChangeColorTheme attribute="color">
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="editImage">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Image </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faUpload')" matTooltip="Menu image" [matMenuTriggerFor]="menu" appChangeColorTheme
            attribute="color" (click)="offerPreviewUpdate.next(element)">
          </fa-icon>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="!isLoadingZipOneOffer"
              (click)="downloadImagesFromOneOffer(element)">Télécharger les images de cette
              offre</button>
            <mat-spinner *ngIf="isLoadingZipOneOffer" [diameter]="30" color="primary"></mat-spinner>
            <p class="subTitleMenu"><b>Image principale</b></p>
            <hr class="horizontalLine">
            <button mat-menu-item (click)="openDialogChooseImageFromClub(element)">Importer une image du club</button>
            <button mat-menu-item (click)="openDialogImportImage(element)">Importer une nouvelle image</button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Éditer </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faPen')" (click)="$event.preventDefault(); editOffer(element)" appChangeColorTheme
            attribute="color" [matTooltip]="getTooltip('editOffer')"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="duplicate">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Dupliquer </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faCopy')" (click)="duplicateOffer(element)"
            [matTooltip]="getTooltip('duplicateOffer')" appChangeColorTheme attribute="color">
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Lien </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faLink')" [matTooltip]="'Copier le lien de l\'offre'"
            (click)="copyString(element.offerKey)" appChangeColorTheme attribute="color"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="isActive">
        <th mat-header-cell mat-sort-header="isActive" *matHeaderCellDef class="cell_IsActive"
          [style.text-align]="'right !important'"> Act./Dés. </th>
        <td mat-cell *matCellDef="let element" class="cell_IsActive">
          <mat-slide-toggle size="large" (toggleChange)="isActivatedOrDeactivated(element)" [color]="color"
            [checked]="element?.isActive"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="rating">
        <th mat-header-cell mat-sort-header="rating" *matHeaderCellDef> Note </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ratingTotal > 0">{{element.rating}}
            <sup *ngIf="element.ratingTotal > 1">
              <fa-icon class="faInfoCircle" [icon]="getFaIcon('faInfoCircle')"
                [matTooltip]="'Moyenne des ' + element.ratingTotal + ' notes réalisées par les utilisateurs de l\'activité'"
                appChangeColorTheme attribute="color"></fa-icon>
            </sup>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [style.border]="row?.offerKey === offer?.offerKey ? '2px solid #2c296d': null">
      </tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </div>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
</div>